var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24135 3.24183V12.7574H6.0106C6.31664 12.7574 6.56487 13.006 6.56487 13.312C6.56487 13.6182 6.31676 13.8666 6.0106 13.8666H3.28516C2.64989 13.8666 2.13281 13.3493 2.13281 12.7139V3.28553C2.13281 2.65033 2.64983 2.1333 3.28516 2.1333H6.01048C6.31666 2.1333 6.56475 2.3813 6.56475 2.68757C6.56475 2.99385 6.31676 3.24183 6.01048 3.24183H3.24135ZM10.8824 4.78666L13.7036 7.60784C13.8076 7.71153 13.8661 7.85263 13.8661 7.9998C13.8661 8.14696 13.8076 8.28794 13.7036 8.39164L10.8825 11.2128C10.7743 11.3211 10.6321 11.3753 10.4902 11.3753C10.3483 11.3753 10.2064 11.3211 10.0981 11.2128C9.8814 10.9962 9.8814 10.6451 10.0981 10.4285L11.9965 8.53103H6.35728C6.05103 8.53103 5.80301 8.28296 5.80301 7.97664C5.80301 7.67036 6.051 7.42238 6.35728 7.42238H11.9502L10.098 5.57036C9.88142 5.35413 9.88152 5.00285 10.0981 4.78662C10.3146 4.57007 10.6657 4.57002 10.8824 4.78666Z",
    fill: "#3A4ADE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.e4b2cbb66363b9526273bec171bc347d.svg";
export { ForwardRef as ReactComponent };